export default __webpack_public_path__ + "static/topNavItems-dont-2-dark-261590aba241140ee831ddebd1e9961f853a5440111fbfd85e99b45e16745f41.png";